<style scoped lang="scss">
.dock-content-div {
    height: fit-content;
    width: 92%;
    background-color: rgb(242 242 242) !important;
    font-size: 12px;
}

.dock_data-div {
    background-color: white;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.parameter_data-div {
    margin-top: 2rem;
    background-color: white;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.api-docs {
    margin-top: 2rem;
    background-color: white;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.8);
    
    .docs-title {
        font-size: 1.5rem;
        font-weight: 600;
        color: #2d3748;
        margin-bottom: 1.5rem;
        padding-bottom: 0.75rem;
        border-bottom: 2px solid #e2e8f0;
        position: relative;
        
        &::after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 0;
            width: 60px;
            height: 2px;
            background: linear-gradient(90deg, #4f46e5, #7c3aed);
        }
    }
    
    .docs-link {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        color: #4f46e5;
        text-decoration: none;
        font-size: 1rem;
        margin-bottom: 2rem;
        padding: 0.75rem 1.25rem;
        background: #f8fafc;
        border-radius: 8px;
        border: 1px solid #e2e8f0;
        transition: all 0.2s ease;
        
        &:hover {
            color: #7c3aed;
            background: #f1f5f9;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(79, 70, 229, 0.1);
        }
        
        .el-icon {
            font-size: 1.1rem;
        }
    }
    
    .api-features {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 1.5rem;
        margin-top: 1.5rem;
        
        .feature-item {
            background: #f8fafc;
            padding: 1.25rem;
            border-radius: 8px;
            border: 1px solid #e2e8f0;
            transition: all 0.2s ease;
            
            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
                border-color: #4f46e5;
            }
            
            .feature-title {
                font-size: 1.1rem;
                font-weight: 500;
                color: #2d3748;
                margin-bottom: 0.5rem;
            }
            
            .feature-desc {
                color: #4a5568;
                font-size: 0.95rem;
                line-height: 1.5;
            }
        }
    }
}

//pc端
@media screen and (min-width: 769px) {
    .parameter_data-div {
        margin-left: 3rem;
        max-width: 45rem;
    }

    .dock_data-div {
        margin-left: 3rem;
        width: 90%;
        margin-top: 1rem;
    }

    .api-docs {
        margin-left: 3rem;
        width: 90%;
    }
}

//移动端
@media screen and (max-width: 768px) {
    .dock_data-div {
        margin-left: 0.5rem;
        min-height: 70vh;
        margin-top: 1rem;
        width: 100%;
    }

    .parameter_data-div {
        margin-top: 1rem;
        margin-left: 0.5rem;
        width: 100%;
    }

    .api-docs {
        margin-top: 1rem;
        margin-left: 0.5rem;
        width: 100%;
        padding: 1.5rem;
        
        .docs-title {
            font-size: 1.25rem;
        }
        
        .api-features {
            grid-template-columns: 1fr;
        }
    }
}

.el-select__wrapper {
    width: 10rem !important;
}

.el-tag-item {
    margin: 0.5rem;
    padding: 1rem 0.5rem;
    font-weight: bold;
}
</style>
<template>
    <div class="common-layout" style="padding-right: 0;">
        <el-container>
            <el-aside style="width: fit-content;">
                <UserHead />
            </el-aside>
            <el-container>
                <el-header style="padding: 0;">
                    <HeadTop />
                </el-header>
                <el-main
                    style="padding: 0;height: 100vh;background-color: rgb(242, 242, 242) !important;overflow: auto; ">
                    <div class="dock-content-div">
                        <div style="margin-bottom: 3rem;">
                            <div class="dock_data-div rounded shadow">
                                <div>
                                    <el-form label-position="left" label-width="auto" :model="dock_data"
                                        style="max-width: 600px">
                                        <el-form-item label="AppId">
                                            <el-input v-model="dock_data.AppId" disabled style="width: 20rem;" />
                                            <el-button type="success" style="margin-left: 1rem;"
                                                @click="copyFun1(dock_data.AppId)">复制</el-button>
                                        </el-form-item>
                                        <el-form-item label="密钥">
                                            <el-input v-model="dock_data.dock_key" @click="copyFun1(dock_data.dock_key)"
                                                disabled style="width: 20rem;" />
                                            <el-button type="success" style="margin-left: 1rem;"
                                                @click="copyFun1(dock_data.dock_key)">复制</el-button>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-button type="primary" style="margin-left: 1rem;"
                                                @click="setDockKey">重置密钥</el-button>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-tag class="el-tag-item" type="warning">请使用亿乐接口对接本站</el-tag>
                                            <el-tag class="el-tag-item" type="warning">无需设置白名单</el-tag>
                                            <el-tag class="el-tag-item" type="warning">首次使用请点击重置密钥</el-tag>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>

                            <div class="api-docs">
                                <div class="docs-title">API对接文档</div>
                                
                                <a href="https://console-docs.apipost.cn/preview/d17fac3f101d4795/c4885e31f99c8c0e" 
                                   target="_blank" 
                                   class="docs-link">
                                    <el-icon><Link /></el-icon>
                                    查看完整接口文档
                                </a>
                                
                                <div class="api-features">
                                    <div class="feature-item">
                                        <div class="feature-title">分类列表接口</div>
                                        <div class="feature-desc">支持查询所有软件分类信息</div>
                                    </div>
                                    <div class="feature-item">
                                        <div class="feature-title">授权商品列表</div>
                                        <div class="feature-desc">支持根据分类ID查询相关商品</div>
                                    </div>
                                    <div class="feature-item">
                                        <div class="feature-title">商品详情接口</div>
                                        <div class="feature-desc">支持根据商品ID查询详细信息</div>
                                    </div>
                                    <div class="feature-item">
                                        <div class="feature-title">用户信息查询</div>
                                        <div class="feature-desc">支持查询用户昵称、余额等信息</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { ElMessage } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import { copyFun, getEmpowerIncludesList } from "@/utils/publicMethods"
import axios from 'axios';
import { Link } from '@element-plus/icons-vue';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop,
        Link
    },
    data() {
        return {
            dock_data: {
                uid: "",
                dock_key: "",
                AppId: "",
                dock_url: "",
                dock_url2: ""
            },
            time_meal_data: {
                select_option: "",
                time_meal_list: [],
                num: 1,
                meal_id: 0,
                min: 1,
                max: 1,
                unit: "",
                price: 1
            },
            includes_data: {
                select_option: "",
                includes_list: []
            },
            empowerApi: {
                host: '',
                user_email: ""
            },
            parameter_data: [
                { "name": "uid", "example": "1000", "desc": "用户编号", "notNull": true },
                { "name": "key", "example": "wred254sfu44d5g1w3t", "desc": "接口密钥", "notNull": true },
                { "name": "includes_id", "example": "1", "desc": "授权插件id", "notNull": true },
                { "name": "time_act", "example": "1", "desc": "时长类型，1表示天，2表示月，3表示年，4表示永久", "notNull": true },
                { "name": "time_num", "example": "10", "desc": "时长份数，比如当时长类型为天时，这里的时长份数填10就是表示10天", "notNull": true },
                { "name": "email", "example": "123456@qq.com", "desc": "被授权者的邮箱，会自动注册为你的下级，若是别人的下级则不会变化", "notNull": true },
                { "name": "host", "example": "ljwx.site", "desc": "被授权者的域名，格式例如：www.baidu.com，不可带http和斜杠/，并且请注意相关插件要求填写一级域名还是后台登录域名", "notNull": true },
            ],
            apiDocs: ""
        }
    }, methods: {
        tableRowClassName(row) {
            let rowIndex = row.rowIndex
            if (rowIndex % 2 == 0) {
                return 'params-row';
            }
            else if (rowIndex % 3 == 0) {
                return 'params-row warning-row';
            }
            else {
                return 'params-row success-row';
            }
        },

        async getDockKey() {
            openLoading()
            var res_data = await getEmpowerIncludesList(999, 1)
            this.includes_data.includes_list = res_data.data
            const data = new FormData();
            data.append("act", "getDockKey")
            const headers = {
                'token': localStorage.getItem("token"),
            }
            axios.post(baseURL + '/userApi/getInfo', data, { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.dock_data = res.data.data
                        this.dock_data.dock_url = window.location.host + "/userApi/empowerByApi?uid=" + this.dock_data.uid + "&key=" + this.dock_data.dock_key +
                            "&includes_id=[插件id]&time_act=[时长类型]&time_num=[份数]&email=[被授权者邮箱]&host=[被授权的域名]";
                        this.apiDocs = res.data.data.dock_url;
                        return;
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        ElMessage.error(res.data.msg)
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        generateKey() {
            let uid = this.dock_data.uid;
            let includes_id = this.includes_data.select_option;
            let meal_id = this.time_meal_data.select_option;
            if (includes_id == "" || meal_id == "") {
                ElMessage.error("请选中插件和插件时长类型")
                return
            }
            let key = this.dock_data.dock_key;
            if (key == "") {
                ElMessage.error("请先刷新密钥")
                return
            }
            this.dock_data.dock_url2 = window.location.host + "/userApi/empowerByApi?uid=" + uid + "&key=" + key + "&includes_id=" + includes_id + "&time_act=" + meal_id +
                "&time_num=[份数]" + "&email=[被授权者邮箱]" + "&host=[被授权的域名]"
            ElMessage.success("快捷生成URL成功")
        },

        setDockKey() {
            if (!confirm("是否重置秘钥?之前的密钥将会失效")) {
                return;
            }
            openLoading()
            const data = new FormData();
            data.append("act", "setDockKey")
            const headers = {
                'token': localStorage.getItem("token"),
            }
            axios.post(baseURL + '/userApi/getInfo', data, { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.dock_data = res.data.data
                        this.dock_data.dock_url = window.location.host + "/userApi/empowerByApi?uid=" + this.dock_data.uid + "&key=" + this.dock_data.dock_key +
                            "&includes_id=[插件id]&time_act=[时长类型]&time_num=[份数]&email=[被授权者邮箱]&host=[被授权的域名]";
                        this.apiDocs = res.data.data.dock_url;
                        return;
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        ElMessage.error(res.data.msg)
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        getTimeMeal(includes_id) {
            openLoading()
            this.time_meal_data.select_option = ""
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            data.append("includes_id", includes_id)
            data.append("act", "getTimeMeal")
            axios.post(baseURL + "/userApi/getInfo", data, { timeout: 30000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 401) {
                        ElMessage.error(res.data.msg)
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    }
                    else if (res.data.code == 200) {
                        this.time_meal_data.time_meal_list = res.data.data
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    ElMessage.error('请求失败：' + err.message)
                })
        },
        copyFun1(text) {
            console.log(text);
            copyFun(text)
        }
    },
    mounted() {
        this.getDockKey()
    }
})
</script>
